import { StyleSheet, TextStyle, ViewStyle } from 'react-native';
import { MARKETPLACE_COLORS } from '@/constants/residents/marketplaceColors';

/**
 * Shared form styles for marketplace input components
 * Used in StepItemDetails, StepPriceCondition, ReportModal, SoldFeedbackModal, LeaveFeedbackModal
 */

interface FormStyles {
  // Input containers
  inputContainer: ViewStyle;
  inputContainerFilled: ViewStyle;
  inputContainerFocused: ViewStyle;
  
  // Text input styles
  textInput: TextStyle;
  textInputPlaceholder: TextStyle;
  
  // Textarea (multiline input)
  textareaContainer: ViewStyle;
  textarea: TextStyle;
  
  // Search input
  searchContainer: ViewStyle;
  searchInput: TextStyle;
  
  // Price input
  priceInputContainer: ViewStyle;
  currencySymbol: TextStyle;
  priceInput: TextStyle;
  
  // Description/Optional input
  descriptionContainer: ViewStyle;
  descriptionInput: TextStyle;
  
  // Labels
  inputLabel: TextStyle;
  inputLabelOptional: TextStyle;
}

export const formStyles = StyleSheet.create<FormStyles>({
  // Basic input container
  inputContainer: {
    backgroundColor: MARKETPLACE_COLORS.inputBackground,
    borderWidth: 1,
    borderColor: MARKETPLACE_COLORS.inputBorder,
    borderRadius: 8,
    paddingHorizontal: 16,
    height: 40,
    justifyContent: 'center',
  },
  inputContainerFilled: {
    borderColor: MARKETPLACE_COLORS.inputBorder,
  },
  inputContainerFocused: {
    borderColor: MARKETPLACE_COLORS.accentBlueSolid,
  },

  // Text input
  textInput: {
    fontSize: 14,
    fontWeight: '400',
    color: MARKETPLACE_COLORS.textPrimary,
    lineHeight: 17.5,
    padding: 0,
  },
  textInputPlaceholder: {
    color: MARKETPLACE_COLORS.textSecondary,
  },

  // Textarea (multiline)
  textareaContainer: {
    backgroundColor: MARKETPLACE_COLORS.inputBackground,
    borderWidth: 1,
    borderColor: MARKETPLACE_COLORS.inputBorder,
    borderRadius: 8,
    minHeight: 80,
  },
  textarea: {
    flex: 1,
    fontSize: 14,
    fontWeight: '400',
    color: MARKETPLACE_COLORS.textPrimary,
    paddingHorizontal: 16,
    paddingVertical: 12,
    lineHeight: 21,
    textAlignVertical: 'top',
  },

  // Search input
  searchContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: MARKETPLACE_COLORS.white5Percent,
    borderRadius: 8,
    paddingHorizontal: 14,
    height: 40,
    gap: 8,
  },
  searchInput: {
    flex: 1,
    fontSize: 14,
    fontWeight: '400',
    color: MARKETPLACE_COLORS.textPrimary,
    lineHeight: 21,
  },

  // Price input
  priceInputContainer: {
    backgroundColor: MARKETPLACE_COLORS.inputBackground,
    borderWidth: 1,
    borderColor: MARKETPLACE_COLORS.inputBorder,
    borderRadius: 8,
    paddingHorizontal: 16,
    height: 40,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  currencySymbol: {
    fontSize: 14,
    fontWeight: '400',
    color: MARKETPLACE_COLORS.textSecondary,
    lineHeight: 17.5,
  },
  priceInput: {
    flex: 1,
    fontSize: 14,
    fontWeight: '400',
    color: MARKETPLACE_COLORS.textPrimary,
    lineHeight: 17.5,
    padding: 0,
    marginLeft: 8,
  },

  // Description/Optional input
  descriptionContainer: {
    backgroundColor: MARKETPLACE_COLORS.inputBackground,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: MARKETPLACE_COLORS.inputBorder,
    height: 80,
  },
  descriptionInput: {
    flex: 1,
    paddingHorizontal: 16,
    paddingTop: 11,
    paddingBottom: 11,
    fontSize: 14,
    fontWeight: '400',
    color: MARKETPLACE_COLORS.textPrimary,
    lineHeight: 17.5,
    textAlignVertical: 'top',
  },

  // Labels
  inputLabel: {
    fontSize: 12,
    fontWeight: '500',
    color: MARKETPLACE_COLORS.textSecondary,
    lineHeight: 18,
    marginBottom: 8,
  },
  inputLabelOptional: {
    color: MARKETPLACE_COLORS.textMuted,
    fontWeight: '400',
  },
});
